import { __awaiter, __generator } from "tslib";
import { SubEntityType } from './models/sub-entity-type';
import { getFetchSubEntitiesUrl } from './utilities/get-fetch-sub-entities-url';
import { fetchGetProductCatalogue } from './http/fetch-get-product-catalogue';
export var fetchGroupService = function (groupId, serviceType, includeType) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = getFetchSubEntitiesUrl(groupId, SubEntityType.Service, "g" /* Group */, includeType);
                url += "&serviceType=" + serviceType;
                return [4 /*yield*/, fetchGetProductCatalogue(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
